const testApi = "http://localhost:5100/api/";
const prodApi = "https://letuscontact.orbiapps.com/api/"

export const currentApi = (process.env.NODE_ENV === "development") ? testApi : prodApi;